import { render } from "./WelcomeImage.vue?vue&type=template&id=89822984&scoped=true"
import script from "./WelcomeImage.vue?vue&type=script&lang=js"
export * from "./WelcomeImage.vue?vue&type=script&lang=js"

import "./WelcomeImage.vue?vue&type=style&index=0&id=89822984&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89822984"]])

export default __exports__